// === Core Variables ===
const bundleSelections = new Map();
let bundleCount = 0;
let selectedBundleOption = null;
let productFormId = '';

// === PRICING CONFIGURATION ===
// Discount % applied per unit at each tier. These are set in the THEME EDITOR
// (Line item selector block -> "Discount per unit" on each option) and injected
// as window.LIS_TIER_DISCOUNTS by the snippet, so the merchant can change them
// with no code. Defaults below are only a fallback. These MUST match the
// Shopify automatic discount(s):  buy 2 -> 20% off,  buy 3+ -> 30% off.
function readTierDiscount(tier, fallback) {
    try {
        const v = window.LIS_TIER_DISCOUNTS && window.LIS_TIER_DISCOUNTS[tier];
        const n = parseFloat(v);
        if (!isNaN(n) && n >= 0 && n < 100) return n;
    } catch (e) {}
    return fallback;
}

const TIER_DISCOUNTS = {
    1: readTierDiscount(1, 0),   // buy 1  -> full price
    2: readTierDiscount(2, 20),  // buy 2  -> 20% off each
    3: readTierDiscount(3, 30)   // buy 3+ -> 30% off each
};

// Reads the REAL, current product price (base-currency cents) straight from the
// variant the theme rendered into the DOM (data-price="{{ variant.price }}").
// This is why the bundle now auto-updates when you change the product price.
function getBasePrice() {
    let cents = 0;
    $('.product-variant[data-price]').each(function () {
        const p = parseInt($(this).attr('data-price'), 10);
        if (!isNaN(p) && p > 0) {
            // Use the first valid variant price as the representative unit price
            // (all colour variants of this product share the same price).
            if (cents === 0) cents = p;
        }
    });
    return cents;
}

// Builds the tier pricing table from the live base price + TIER_DISCOUNTS.
function buildPricing(baseCents) {
    baseCents = Number(baseCents) || 0;

    function makeTier(label, discountPct, quantity) {
        const perUnitDiscounted = Math.round(baseCents * (100 - discountPct) / 100);
        const savingsPerUnit = baseCents - perUnitDiscounted;
        return {
            label: label,
            perUnitOriginal: baseCents,
            perUnitDiscounted: perUnitDiscounted,
            savingsPerUnit: savingsPerUnit,
            totalSavings: savingsPerUnit * quantity, // representative saving for this tier
            savingsText: savingsPerUnit > 0 ? ('SAVE ' + formatBaseMoney(savingsPerUnit * quantity)) : ''
        };
    }

    return {
        basePrice: baseCents,
        tiers: {
            1: makeTier('1 Glimmr', TIER_DISCOUNTS[1], 1),
            2: makeTier('2 Glimmrs', TIER_DISCOUNTS[2], 2),
            3: makeTier('3+ Glimmrs', TIER_DISCOUNTS[3], 3)
        }
    };
}

// Rebuilt from the live product price on load (see $(document).ready). Starts
// from an empty table so any early calls are harmless until the DOM is ready.
let PRICING = buildPricing(0);

// === CURRENCY CONVERSION (via the store's Geolocation/GLC app) ===
// This store's prices are rendered by Shopify in the SHOP's base currency (AUD)
// and converted on the client by the GLC currency app. GLC finds prices by CSS
// selector - its price selector always includes ".glc-money" - reads the base
// amount, and rewrites it into the shopper's selected currency (also re-running
// via a MutationObserver whenever the DOM changes). The old bundle printed
// prices into <free-gift-text>/plain spans that match none of GLC's selectors,
// so GLC skipped them. The fix: emit every bundle price as base-currency text
// wrapped in <span class="glc-money"> so GLC converts it exactly like the
// theme's normal prices. We do NOT convert amounts ourselves - GLC owns that.

// Money format for the shop's base currency, injected by the snippet from
// {{ shop.money_format }} (falls back to "${{amount}}").
function getBaseMoneyFormat() {
    return (typeof window !== 'undefined' && window.LIS_MONEY_FORMAT) || '${{amount}}';
}

// Classic Shopify money formatter: turns cents into a base-currency string using
// the shop's money_format, so GLC's parser recognises it.
function formatBaseMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    format = format || getBaseMoneyFormat();

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = (precision === undefined || precision === null) ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) return '0';

        number = (Number(number) / 100).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? (decimal + parts[1]) : '';
        return dollars + centsPart;
    }

    const match = format.match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';
    let value = '';

    switch (placeholder) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', '');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
}

// Returns a base-currency price wrapped so the GLC app converts it.
// IMPORTANT: this returns HTML, so callers must use .html(), not .text().
function formatMoney(cents) {
    return '<span class="glc-money">' + formatBaseMoney(cents) + '</span>';
}

// Backwards-compatible wrapper (old signature accepted a symbol arg, now unused).
function formatCurrency(cents, symbol = null) {
    return formatMoney(cents);
}

// Legacy helper retained in case any other code references it.
function getCurrencySymbol() {
    return '$';
}

// === Get Product Form ID ===
function getProductFormId() {
    if (productFormId) return productFormId;
    
    const $formIdElement = $('[data-form-id]').first();
    if ($formIdElement.length) {
        productFormId = $formIdElement.data('form-id');
        return productFormId;
    }
    
    const $form = $('form.product-form, form[action*="/cart/add"]').first();
    if ($form.length) {
        productFormId = $form.attr('id');
        return productFormId;
    }
    
    const section = document.querySelector('[data-section]');
    productFormId = section ? `product-form-${section.dataset.section}` : 'product-form-main';
    return productFormId;
}

// === Get current bundle total ===
function getBundleTotal() {
    let totalCents = 0;
    for (const [id, qty] of bundleSelections) {
        const priceCents = parseInt($(`.product-variant[data-id="${id}"]`).attr('data-price'), 10) || 0;
        totalCents += priceCents * (Number(qty) || 0);
    }
    return totalCents;
}

// === Get discount rate based on bundle count ===
function getDiscountRate() {
    if (bundleCount >= 3) return 30;
    if (bundleCount === 2) return 20;
    return 0;
}

// === Get tier data for current bundle count ===
function getCurrentTierData() {
    if (bundleCount === 1) {
        return PRICING.tiers[1];
    } else if (bundleCount === 2) {
        return PRICING.tiers[2];
    } else if (bundleCount >= 3) {
        return PRICING.tiers[3];
    }
    return null;
}

// === Get option data for a specific tier ===
function getOptionData(optionCount) {
    if (optionCount === 1) {
        return PRICING.tiers[1];
    } else if (optionCount === 2) {
        return PRICING.tiers[2];
    } else if (optionCount >= 3) {
        return PRICING.tiers[3];
    }
    return null;
}

// === Calculate pricing for current bundle ===
function calculatePricing() {
    const tierData = getCurrentTierData();
    if (!tierData || bundleCount === 0) {
        return {
            perUnitOriginal: 0,
            perUnitDiscounted: 0,
            totalOriginal: 0,
            totalDiscounted: 0,
            totalSavings: 0,
            savingsPerUnit: 0
        };
    }
    
    const perUnitOriginal = PRICING.basePrice;
    const perUnitDiscounted = tierData.perUnitDiscounted;
    const totalOriginal = perUnitOriginal * bundleCount;
    const totalDiscounted = perUnitDiscounted * bundleCount;
    const totalSavings = totalOriginal - totalDiscounted;
    const savingsPerUnit = perUnitOriginal - perUnitDiscounted;
    
    return {
        perUnitOriginal,
        perUnitDiscounted,
        totalOriginal,
        totalDiscounted,
        totalSavings,
        savingsPerUnit
    };
}

// === Update Bundle Count and UI ===
function updateBundleCount() {
    let total = 0;
    for (const q of bundleSelections.values()) total += Number(q) || 0;
    bundleCount = total;

    // Update meter
    const $meter = $('.select_variants_meter span');
    if ($meter.length) {
        let percentage = 0;
        if (bundleCount === 0) percentage = 0;
        else if (bundleCount === 1) percentage = 0;
        else if (bundleCount === 2) percentage = 50;
        else if (bundleCount >= 3) percentage = 100;
        $meter.css('width', percentage + '%');
    }

    // Update option circles
    updateOptionCircles();
    updateOptionDisplay();
    updateAddToCartButton();
    updateSavingsDisplay();
}

// === Update Option Circles State ===
function updateOptionCircles() {
    const $opt1 = $('#bundle_option_1');
    const $opt2 = $('#bundle_option_2');
    const $opt3 = $('#bundle_option_3');

    // Update selection states
    $opt1.toggleClass('selected', bundleCount >= 1);
    $opt2.toggleClass('selected', bundleCount >= 2);
    $opt3.toggleClass('selected', bundleCount >= 3);

    // Update active states (which tier is currently achieved)
    $opt1.toggleClass('active', bundleCount === 1);
    $opt2.toggleClass('active', bundleCount === 2);
    $opt3.toggleClass('active', bundleCount >= 3);
}

// === Update Option Display ===
function updateOptionDisplay() {
    const symbol = getCurrencySymbol();
    
    // Option 1: 1 Glimmr - $89.99
    const $opt1Label = $('#bundle_option_1 rt');
    const $opt1Price = $('#bundle_option_1 free-gift-text');
    if ($opt1Label.length) {
        $opt1Label.text('1 Glimmr');
    }
    if ($opt1Price.length) {
        $opt1Price.html(formatCurrency(PRICING.tiers[1].perUnitDiscounted, symbol));
    }
    
    // Option 2: 2 Glimmrs - $76.19/ea
    const $opt2Label = $('#bundle_option_2 rt');
    const $opt2Price = $('#bundle_option_2 free-gift-text');
    if ($opt2Label.length) {
        $opt2Label.text('2 Glimmrs');
    }
    if ($opt2Price.length) {
        $opt2Price.html(formatCurrency(PRICING.tiers[2].perUnitDiscounted, symbol) + '/ea');
    }
    
    // Option 3: 3+ Glimmrs - $69.29/ea
    const $opt3Label = $('#bundle_option_3 rt');
    const $opt3Price = $('#bundle_option_3 free-gift-text');
    if ($opt3Label.length) {
        $opt3Label.text('3+ Glimmrs');
    }
    if ($opt3Price.length) {
        $opt3Price.html(formatCurrency(PRICING.tiers[3].perUnitDiscounted, symbol) + '/ea');
    }

    // Save badges - render from the pricing model so they convert with currency
    // (static server text like "Save $17.8" cannot convert on its own).
    // "free shipping" is added as a second line under the Save amount (options
    // 2 and 3 only), per the client's mock. Text only - it inherits the badge's
    // existing style, no other changes.
    const freeShipLine = '<br><span class="free-ship-note">free shipping</span>';
    const $opt2Save = $('#bundle_option_2 .save_box');
    if ($opt2Save.length && PRICING.tiers[2].totalSavings > 0) {
        $opt2Save.html('Save ' + formatMoney(PRICING.tiers[2].totalSavings) + freeShipLine);
    }
    const $opt3Save = $('#bundle_option_3 .save_box');
    if ($opt3Save.length && PRICING.tiers[3].totalSavings > 0) {
        $opt3Save.html('Save ' + formatMoney(PRICING.tiers[3].totalSavings) + freeShipLine);
    }
}

// === UPDATE SAVINGS DISPLAY ===
function updateSavingsDisplay() {
    const symbol = getCurrencySymbol();
    const pricing = calculatePricing();
    
    const $savings = $('#you_are_saving');
    if ($savings.length) {
        if (bundleCount >= 1 && pricing.totalSavings > 0) {
            // Show total savings with per-unit breakdown
            $savings.html(`
                ${formatCurrency(pricing.totalSavings, symbol)}
                <span class="per-unit-savings">(${formatCurrency(pricing.savingsPerUnit, symbol)}/ea)</span>
            `).show();
        } else if (bundleCount >= 1) {
            // Show $0.00 when no savings (1 item selected)
            $savings.html(formatCurrency(0, symbol)).show();
        } else {
            // No items selected
            $savings.html(formatCurrency(0, symbol)).show();
        }
    }
}

// === UPDATE ADD TO CART BUTTON ===
function updateAddToCartButton() {
    const $btn = $('#variant_bundle_add_to_cart');
    
    if (!$btn.length) {
        console.warn('Bundle ATC button not found');
        return;
    }

    const tierData = getCurrentTierData();
    const pricing = calculatePricing();
    const symbol = getCurrencySymbol();

    const $textSpan = $btn.find('.bundle-atc-text');
    const $priceSpan = $btn.find('.bundle-atc-price');
    const $comparePrice = $btn.find('.compare-price');
    const $finalPrice = $btn.find('.final-price');

    if (bundleCount >= 1 && tierData) {
        // Enable button
        $btn.prop('disabled', false).removeAttr('disabled');
        $btn.addClass('active');
        
        // Update text
        if ($textSpan.length) {
            if (bundleCount === 1) {
                $textSpan.text('Add 1 Glimmr to Cart');
            } else if (bundleCount === 2) {
                $textSpan.text('Add 2 Glimmrs to Cart');
            } else if (bundleCount >= 3) {
                $textSpan.text('Add ' + bundleCount + ' Glimmrs to Cart');
            }
        }
        
        // Update price
        if ($priceSpan.length) {
            const totalOriginal = pricing.totalOriginal;
            const totalDiscounted = pricing.totalDiscounted;
            
            // For 1 item: just show the final price (no strikethrough)
            if (bundleCount === 1) {
                $comparePrice.hide();
                $finalPrice.html(formatCurrency(totalDiscounted, symbol)).show();
            } 
            // For 2 or more items: show original price with strikethrough and discounted price
            else if (bundleCount >= 2 && totalOriginal > totalDiscounted) {
                $comparePrice.html(formatCurrency(totalOriginal, symbol)).show();
                $finalPrice.html(formatCurrency(totalDiscounted, symbol)).show();
            } else {
                $comparePrice.hide();
                $finalPrice.html(formatCurrency(totalDiscounted, symbol)).show();
            }
            $priceSpan.show();
        }
        
        // Update main ATC button
        const formId = getProductFormId();
        const sectionId = formId.replace('product-form-', '');
        const $mainBtn = $(`#ProductSubmitButton-${sectionId}`);
        if ($mainBtn.length) {
            $mainBtn.prop('disabled', false).removeAttr('disabled');
            const $mainLabel = $mainBtn.find('.main-atc__label__text');
            if ($mainLabel.length) {
                if (bundleCount === 1) {
                    $mainLabel.text('Add 1 Glimmr');
                } else if (bundleCount === 2) {
                    $mainLabel.text('Add 2 Glimmrs');
                } else if (bundleCount >= 3) {
                    $mainLabel.text('Add ' + bundleCount + ' Glimmrs');
                }
            }
            const $mainPrice = $mainBtn.find('.main-atc-price');
            if ($mainPrice.length) {
                const totalOriginal = pricing.totalOriginal;
                const totalDiscounted = pricing.totalDiscounted;
                
                if (bundleCount === 1) {
                    $mainPrice.html(`${formatCurrency(totalDiscounted, symbol)}`);
                } else if (bundleCount >= 2 && totalOriginal > totalDiscounted) {
                    $mainPrice.html(`<s>${formatCurrency(totalOriginal, symbol)}</s> ${formatCurrency(totalDiscounted, symbol)}`);
                } else {
                    $mainPrice.html(`${formatCurrency(totalDiscounted, symbol)}`);
                }
                $mainPrice.show();
            }
        }
        
        // Update sticky ATC
        const $stickyBtn = $(`#SectionAtcBtn-${sectionId}`);
        const $stickyPrice = $(`#sticky-atc-price-${sectionId}`);
        if ($stickyBtn.length) {
            $stickyBtn.prop('disabled', false).removeAttr('disabled');
            if ($stickyPrice.length) {
                const totalOriginal = pricing.totalOriginal;
                const totalDiscounted = pricing.totalDiscounted;
                
                if (bundleCount === 1) {
                    $stickyPrice.html(`${formatCurrency(totalDiscounted, symbol)} •`);
                } else if (bundleCount >= 2 && totalOriginal > totalDiscounted) {
                    $stickyPrice.html(`<s>${formatCurrency(totalOriginal, symbol)}</s> ${formatCurrency(totalDiscounted, symbol)} •`);
                } else {
                    $stickyPrice.html(`${formatCurrency(totalDiscounted, symbol)} •`);
                }
                $stickyPrice.show();
            }
        }
        
        // Update separate price display
        const $priceDisplay = $(`#main-atc-price-${sectionId}`);
        if ($priceDisplay.length) {
            const totalOriginal = pricing.totalOriginal;
            const totalDiscounted = pricing.totalDiscounted;
            
            if (bundleCount === 1) {
                $priceDisplay.html(`${formatCurrency(totalDiscounted, symbol)} •`);
            } else if (bundleCount >= 2 && totalOriginal > totalDiscounted) {
                $priceDisplay.html(`<s>${formatCurrency(totalOriginal, symbol)}</s> ${formatCurrency(totalDiscounted, symbol)} •`);
            } else {
                $priceDisplay.html(`${formatCurrency(totalDiscounted, symbol)} •`);
            }
            $priceDisplay.removeClass('hidden');
        }
        
    } else {
        // === NO ITEMS SELECTED ===
        $btn.prop('disabled', true).attr('disabled', 'disabled');
        $btn.removeClass('active');
        
        if ($textSpan.length) {
            $textSpan.text('Add at least 1 Glimmr');
        }
        if ($priceSpan.length) {
            $priceSpan.hide();
        }
        
        const formId = getProductFormId();
        const sectionId = formId.replace('product-form-', '');
        const $mainBtn = $(`#ProductSubmitButton-${sectionId}`);
        if ($mainBtn.length) {
            $mainBtn.prop('disabled', true).attr('disabled', 'disabled');
            const $mainLabel = $mainBtn.find('.main-atc__label__text');
            if ($mainLabel.length) {
                $mainLabel.text('Select items first');
            }
            const $mainPrice = $mainBtn.find('.main-atc-price');
            if ($mainPrice.length) {
                $mainPrice.hide();
            }
        }
        
        const $stickyPrice = $(`#sticky-atc-price-${sectionId}`);
        if ($stickyPrice.length) {
            $stickyPrice.hide();
        }
        
        const $priceDisplay = $(`#main-atc-price-${sectionId}`);
        if ($priceDisplay.length) {
            $priceDisplay.addClass('hidden');
        }
        
        const $stickyBtn = $(`#SectionAtcBtn-${sectionId}`);
        if ($stickyBtn.length) {
            $stickyBtn.prop('disabled', true).attr('disabled', 'disabled');
        }
    }
}

// === Click on Bundle Option to Auto-Select Quantity ===
$(document).on('click', '#bundle_option_1, #bundle_option_2, #bundle_option_3', function() {
    const optionIndex = $(this).data('option-index');
    const targetCount = parseInt(optionIndex, 10); // 1, 2, or 3
    
    // Clear current selections
    bundleSelections.clear();
    
    // Get available variants
    const $variants = $('.product-variant');
    if ($variants.length === 0) return;
    
    // Select the first variant and set quantity to target count
    const $firstVariant = $variants.first();
    const variantId = String($firstVariant.data('id'));
    
    // Set quantity based on option
    bundleSelections.set(variantId, targetCount);
    
    // Update UI for all variants
    $variants.each(function(index) {
        const $variant = $(this);
        const id = String($variant.data('id'));
        
        if (id === variantId) {
            // This is the selected variant
            $variant.find('.quantity-selector').show();
            $variant.find('.add.step').hide();
            $variant.find('.quantity-input').val(targetCount);
        } else {
            // Other variants - deselect
            $variant.find('.quantity-selector').hide();
            $variant.find('.add.step').show();
            $variant.find('.quantity-input').val(1);
        }
    });
    
    // Update active state
    $('#bundle_option_1, #bundle_option_2, #bundle_option_3').removeClass('active');
    $(this).addClass('active');
    
    // Update bundle
    bundleCount = targetCount;
    updateBundleCount();
});

// === Add button click - increments quantity ===
$(document).on('click', '.product-variant .add.step', function(e) {
    e.preventDefault();
    const $variant = $(this).closest('.product-variant');
    const variantId = String($variant.data('id'));

    // Get current quantity for this variant
    const $input = $variant.find('.quantity-input');
    const currentQty = parseInt($input.val(), 10) || 1;
    
    // Show quantity selector, hide add button
    $variant.find('.quantity-selector').show();
    $(this).hide();

    // Update bundle selection
    bundleSelections.set(variantId, currentQty);
    updateBundleCount();
});

// === Quantity buttons ===
$(document).on('click', '.product-variant .quantity-btn', function(e) {
    e.preventDefault();
    const $variant = $(this).closest('.product-variant');
    const variantId = String($variant.data('id'));
    const $input = $variant.find('.quantity-input');
    let qty = parseInt($input.val(), 10) || 1;

    if ($(this).hasClass('increase')) {
        qty += 1;
    } else if ($(this).hasClass('decrease')) {
        qty -= 1;
    }

    if (qty <= 0) {
        // Remove from bundle
        bundleSelections.delete(variantId);
        $variant.find('.quantity-selector').hide();
        $variant.find('.add.step').show();
        $input.val(1);
    } else {
        // Update quantity
        $input.val(qty);
        bundleSelections.set(variantId, qty);
    }
    updateBundleCount();
});

// === Add to Cart Function ===
function addBundleToCart() {
    const items = Array.from(bundleSelections.entries());
    
    if (!items.length) {
        alert('Please select at least one item');
        return;
    }

    const $btn = $('#variant_bundle_add_to_cart');
    if (!$btn.length) {
        console.error('Bundle Add to Cart button not found');
        return;
    }
    
    // Save original HTML content
    const $textSpan = $btn.find('.bundle-atc-text');
    const $priceSpan = $btn.find('.bundle-atc-price');
    const originalText = $textSpan.length ? $textSpan.text() : $btn.text();
    const originalPriceHtml = $priceSpan.length ? $priceSpan.html() : '';
    
    // Show loading state
    if ($textSpan.length) {
        $textSpan.text('Adding...');
    } else {
        $btn.text('Adding...');
    }
    if ($priceSpan.length) {
        $priceSpan.hide();
    }
    $btn.prop('disabled', true);
    $btn.removeClass('active');

    const cartItems = items.map(([id, quantity]) => {
        const item = {
            id: Number(id),
            quantity: Number(quantity)
        };
        
        const $variant = $(`.product-variant[data-id="${id}"]`);
        if ($variant.length) {
            const inventory = parseInt($variant.attr('data-inventory'), 10);
            const preorderText = $variant.attr('data-preorder-text');
            
            if (inventory <= 0 && preorderText) {
                item.properties = { 'Pre-order': preorderText };
            }
        }
        
        return item;
    });

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: cartItems }),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(response) {
            console.log('Bundle items added to cart:', response);
            
            // Show success state
            if ($textSpan.length) {
                $textSpan.text('Added! ✓');
            } else {
                $btn.text('Added! ✓');
            }
            if ($priceSpan.length) {
                $priceSpan.hide();
            }
            
            setTimeout(() => {
                // Restore original content
                if ($textSpan.length) {
                    $textSpan.text(originalText);
                }
                if ($priceSpan.length && originalPriceHtml) {
                    $priceSpan.html(originalPriceHtml).show();
                }
                $btn.prop('disabled', false);
                $btn.addClass('active');
                // Re-run update to show correct prices
                updateAddToCartButton();
            }, 1500);
            
            bundleSelections.clear();
            bundleCount = 0;
            updateBundleCount();
            
            $('.product-variant .quantity-selector').hide();
            $('.product-variant .add.step').show();
            $('.product-variant .quantity-input').val(1);
            
            forceCartDrawerUpdate();
            
            setTimeout(function() {
                openCartDrawer();
            }, 400);
            
        },
        error: function(xhr) {
            // Restore original content
            if ($textSpan.length) {
                $textSpan.text(originalText);
            } else {
                $btn.text(originalText);
            }
            if ($priceSpan.length && originalPriceHtml) {
                $priceSpan.html(originalPriceHtml).show();
            }
            $btn.prop('disabled', false);
            $btn.addClass('active');
            
            let errorMsg = 'Failed to add items to cart. Please try again.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMsg = xhr.responseJSON.message;
            }
            alert(errorMsg);
            console.error('Add to cart failed:', xhr);
        }
    });
}

// === FORCE CART DRAWER UPDATE ===
function forceCartDrawerUpdate() {
    console.log('Forcing cart drawer update...');
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (cart.item_count > 0) {
                    cartDrawer.classList.remove('is-empty');
                } else {
                    cartDrawer.classList.add('is-empty');
                }
            })
            .catch(() => {});
        
        if (typeof cartDrawer.renderContents === 'function') {
            fetch('/cart')
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCartDrawer = doc.querySelector('cart-drawer');
                    if (newCartDrawer) {
                        const innerContent = newCartDrawer.querySelector('.drawer__inner');
                        if (innerContent) {
                            const currentInner = cartDrawer.querySelector('.drawer__inner');
                            if (currentInner) {
                                currentInner.innerHTML = innerContent.innerHTML;
                            }
                        }
                    }
                })
                .catch(() => {});
        }
        
        if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
        }
    }
    
    const cartItems = document.querySelector('cart-items, cart-drawer-items');
    if (cartItems) {
        if (typeof cartItems.updateCart === 'function') {
            cartItems.updateCart();
        }
        if (typeof cartItems.renderContents === 'function') {
            fetch('/cart')
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newItems = doc.querySelector('cart-items, cart-drawer-items');
                    if (newItems && cartItems) {
                        cartItems.innerHTML = newItems.innerHTML;
                    }
                })
                .catch(() => {});
        }
    }
    
    if (typeof window.publish === 'function') {
        try {
            window.publish('cartUpdate', { source: 'bundle' });
        } catch(e) {}
    }
    
    $(document).trigger('cart:updated');
    $(document).trigger('cart-updated');
    $(document).trigger('cart:refresh');
    $(document).trigger('cart:update');
    
    updateCartCount();
}

// === UPDATE CART COUNT ===
function updateCartCount() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const count = cart.item_count || 0;
            const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart__count, .cart-counter, .header__cart-count, .cart-count');
            cartCountElements.forEach(el => {
                el.textContent = count;
                el.style.display = count > 0 ? '' : 'none';
            });
            
            const headingText = document.querySelector('.drawer__heading');
            if (headingText) {
                const heading = headingText.textContent || '';
                const newHeading = heading.replace(/\(?\d+\)?\s*items?/, count + ' items');
                if (newHeading !== heading) {
                    headingText.textContent = newHeading;
                }
            }
        })
        .catch(() => {});
}

// === OPEN CART DRAWER ===
function openCartDrawer() {
    console.log('Opening cart drawer...');
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            console.log('Cart drawer opened via open()');
            return;
        }
    }
    
    const clickSelectors = [
        '[data-cart-drawer-trigger]',
        '.cart-drawer-toggle',
        '[data-drawer-trigger="cart"]',
        '.cart-icon',
        '.cart-link',
        '[data-cart-toggle]',
        '.header__icon--cart',
        '.cart__open',
        '[aria-controls="CartDrawer"]',
        '[data-drawer="cart"]',
        '.js-cart-drawer-open'
    ];
    
    for (const selector of clickSelectors) {
        const $el = $(selector);
        if ($el.length) {
            $el.trigger('click');
            console.log('Cart drawer opened via click: ' + selector);
            return;
        }
    }
    
    const themeFunctions = [
        window.openCart,
        window.theme?.openCart,
        window.CartDrawer?.open,
        window.openCartDrawer
    ];
    
    for (const fn of themeFunctions) {
        if (typeof fn === 'function') {
            fn();
            console.log('Cart drawer opened via theme function');
            return;
        }
    }
    
    try {
        document.dispatchEvent(new CustomEvent('cart:open'));
        $(document).trigger('cart:open');
        console.log('Cart drawer opened via custom event');
        return;
    } catch(e) {}
    
    if (cartDrawer) {
        cartDrawer.classList.add('active');
        console.log('Cart drawer force opened via class');
    }
}

// === Helper notification ===
function showNotification(message) {
    const $notification = $('<div class="bundle-notification">')
        .text(message)
        .css({
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#333',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '14px',
            zIndex: '9999',
            opacity: '0',
            transition: 'opacity 0.3s ease'
        })
        .appendTo('body');
    
    setTimeout(() => {
        $notification.css('opacity', '1');
    }, 100);
    
    setTimeout(() => {
        $notification.css('opacity', '0');
        setTimeout(() => {
            $notification.remove();
        }, 300);
    }, 2500);
}

// === BUNDLE ADD TO CART BUTTON CLICK ===
$(document).on('click', '#variant_bundle_add_to_cart', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (bundleSelections.size > 0) {
        addBundleToCart();
    } else {
        alert('Please select at least one item');
    }
    return false;
});

// === PREVENT MAIN FORM SUBMISSION WHEN BUNDLE IS ACTIVE ===
$(document).on('submit', function(e) {
    const formId = getProductFormId();
    const $form = $(e.target);
    
    if ($form.is(`#${formId}`) || $form.is('form.product-form')) {
        if (bundleSelections.size > 0 || $('.select_variants_progress').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            if (bundleSelections.size > 0) {
                addBundleToCart();
            }
            return false;
        }
    }
});

// === KEYBOARD SUPPORT ===
$(document).on('keydown', '#variant_bundle_add_to_cart', function(e) {
    if ((e.key === 'Enter' || e.keyCode === 13) && bundleSelections.size > 0) {
        e.preventDefault();
        addBundleToCart();
    }
});

// === CLEANUP ===
window.addEventListener('beforeunload', function() {
    bundleSelections.clear();
    bundleCount = 0;
});

// === INITIALIZATION ===
$(document).ready(function() {
    productFormId = getProductFormId();
    console.log('Product Form ID:', productFormId);

    // Build the tier pricing from the LIVE product price so the bundle always
    // reflects the current price set in Shopify admin (no hardcoded amounts).
    PRICING = buildPricing(getBasePrice());
    console.log('Bundle base price (cents):', PRICING.basePrice);

    // Initialize all variant selectors to hidden
    $('.product-variant .quantity-selector').hide();
    $('.product-variant .add.step').show();
    $('.product-variant .quantity-input').val(1);

    // Set initial labels and prices
    const symbol = getCurrencySymbol();
    
    // Option 1: 1 Glimmr - $89.99
    $('#bundle_option_1 rt').text('1 Glimmr');
    $('#bundle_option_1 free-gift-text').html(formatCurrency(PRICING.tiers[1].perUnitDiscounted, symbol));
    
    // Option 2: 2 Glimmrs - $76.19/ea
    $('#bundle_option_2 rt').text('2 Glimmrs');
    $('#bundle_option_2 free-gift-text').html(formatCurrency(PRICING.tiers[2].perUnitDiscounted, symbol) + '/ea');
    
    // Option 3: 3+ Glimmrs - $69.29/ea
    $('#bundle_option_3 rt').text('3+ Glimmrs');
    $('#bundle_option_3 free-gift-text').html(formatCurrency(PRICING.tiers[3].perUnitDiscounted, symbol) + '/ea');
    
    // Update initial state
    updateBundleCount();
    
    // Set initial savings display
    const $savings = $('#you_are_saving');
    if ($savings.length) {
        $savings.html(formatCurrency(0, symbol));
    }
});

// === DEBUG ===
window.debugBundle = function() {
    console.log('Product Form ID:', getProductFormId());
    console.log('Bundle Selections:', Array.from(bundleSelections.entries()));
    console.log('Bundle Count:', bundleCount);
    console.log('Current Tier:', getCurrentTierData());
    console.log('Pricing:', calculatePricing());
    console.log('Pricing Config:', PRICING);
};

console.log('Bundle cart functionality loaded successfully!');
console.log('Product Form ID:', getProductFormId());
console.log('Use debugBundle() in console to check current state');